<template>
  <button
    class="flex ml-auto bg-theme-2 px-4 py-1 rounded-full shadow-md"
    @click="$emit('click')"
  >
    <DownloadIcon class="h-4 report-box__icon" />
  </button>
</template>

<script>
export default {
  name: "DownloadChart"
};
</script>
